export const roundTheCurrentTimeToMinutes = () => {
	const minute = 60 * 1000
	const time = new Date(Math.floor(Date.now() / minute) * minute).toISOString()

	return time
}
